import { render } from "./ColorDropdown.vue?vue&type=template&id=d0dcbeb2&scoped=true"
import script from "./ColorDropdown.vue?vue&type=script&lang=js"
export * from "./ColorDropdown.vue?vue&type=script&lang=js"

import "./ColorDropdown.vue?vue&type=style&index=0&id=d0dcbeb2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d0dcbeb2"

export default script